/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》证据信息模块
 */
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import {zjlxType, yjwjType} from "@/filters";
export default {
    name: 'ZJXX',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 数据
            data: {},
            // 转换后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 获取基本数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/xwzj/zjxxs', params);
        },

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('证据类型', data.nZjlx));
            _transformItemData.push(this.getRowData('证据名称', data.cZjmc));
            _transformItemData.push(this.getRowData('原件原物', data.nYjwj));
            _transformItemData.push(this.getRowData('证据来源', data.cZjly));
            return _transformItemData;
        },

        /**
         * 获取数据
         * */
        getData() {
            // 请求保全基本信息数据
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _data = res.data;
                const _transformData = [];
                // 证据类型名称
                _data.nZjlxName = zjlxType(res.data.nZjlx);
                // 证据类型名称
                _data.nYjwjName = yjwjType(res.data.nYjwj);
                // 转化之后的数据
                _transformData.push(this.getTransformData(_data));
                this.data = _data;
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.basicData);
            });
        }
    }
};
